export default __webpack_public_path__ + "static/media/ltc.04aeda5c.svg";